import DesktopIconInterface from './Interface';
import type { DesktopIconProps } from './Interface';

/** Thin container — desktop icon is presentational. */
export default function DesktopIconContainer(props: DesktopIconProps) {
  return <DesktopIconInterface {...props} />;
}
